import { Link, useLocation } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEOHead from "@/components/SEOHead";

export default function NotFound() {
  const location = useLocation();

  return (
    <>
      <SEOHead
        title="页面未找到 | 51吃瓜网今日吃瓜资源"
        description="您访问的页面不存在，返回51吃瓜网首页浏览今日大瓜、每日大赛等热门吃瓜资讯。"
        canonicalUrl="http://yuefenggroup.cn/"
      />
      <Navbar />
      <main className="min-h-[70vh] flex flex-col items-center justify-center px-4 text-center">
        <div className="relative">
          <span className="text-8xl md:text-[10rem] font-black text-background-100 select-none pointer-events-none absolute -top-16 left-1/2 -translate-x-1/2">
            404
          </span>
          <div className="relative z-10">
            <i className="ri-emotion-unhappy-line text-5xl md:text-6xl text-foreground-300 mb-6" />
            <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              页面未找到
            </h1>
            <p className="text-foreground-500 mb-2">
              您访问的页面不存在或已被移除
            </p>
            <p className="text-sm text-foreground-400 font-mono mb-8">
              {location.pathname}
            </p>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors"
            >
              <i className="ri-home-line" />
              返回首页
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}